import { getByUrl, getById, create, getAll, update, deleteWheel, getStats } from '../../services/wheel.api'

const state = {
  items: []
}

const getters = {
  wheels: (state) => {
    return state.items
  },
  getWheelById: (state) => (id) => {
    return state.items.find(item => (item.id === id))
  },
  getWheelByUrl: (state) => (url) => {
    if (url.length === 0 || url == 'all') {
        return state.items
    }
    return state.items.filter(wheel => url == wheel.url)
  }
}

// actions
const actions = {
  async loadWheels ({ commit, rootGetters }) {
    let sitekey = rootGetters['account/currentSitekey']

    const wheels = await getAll(sitekey)
    commit('RESET_WHEEL_ITEMS')
    commit('ADD_WHEEL_ITEMS', { items: wheels })
    return wheels
  },

  async loadWheelById ({ commit, rootGetters }, { id }) {
    let sitekey = rootGetters['account/currentSitekey']

    const wheel = await getById(sitekey, id)
    commit('UPDATE_WHEEL_ITEM', { item: wheel })
    return wheel
  },

  async loadWheelByUrl ({ commit, rootGetters }, { url }) {
    let sitekey = rootGetters['account/currentSitekey']

    const wheel = await getByUrl(sitekey, url)
    commit('UPDATE_WHEEL_ITEM', { item: wheel })
    return wheel
  },

  resetWheels ({ commit }) {
    return new Promise((resolve) => {
      commit('RESET_WHEEL_ITEMS')
      resolve()
    })
  },

  async getStepStats ({ rootGetters }, { id }) {
    let sitekey = rootGetters['account/currentSitekey']

    const stats = await getStats(sitekey, id)
    return stats
  },

  async addWheel ({ commit, rootGetters }, wheel) {
    const sitekey = rootGetters['account/currentSitekey']

    const newWheel = await create(sitekey, wheel)
    commit('ADD_WHEEL_ITEM', { item: newWheel })
    return newWheel
  },

  async updateWheel ({ commit, rootGetters }, wheel) {
    const sitekey = rootGetters['account/currentSitekey']

    const newWheel = await update(sitekey, wheel)
    commit('UPDATE_WHEEL_ITEM', { item: newWheel })
    return newWheel
  },

  async removeWheel ({ commit, rootGetters }, wheel) {
    const sitekey = rootGetters['account/currentSitekey']

    await deleteWheel(sitekey, wheel)
    commit('REMOVE_WHEEL_ITEM', { item: wheel })
  },
}

// mutations
const mutations = {
  ADD_WHEEL_ITEMS (state, { items }) {
    state.items.push(...items)
  },

  ADD_WHEEL_ITEM (state, { item }) {
    state.items.push(item)
  },

  RESET_WHEEL_ITEMS (state) {
    state.items = []
  },

  UPDATE_WHEEL_ITEM (state, { item }) {
    let find = false

    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i].id === item.id) {
        Object.assign(state.items[i], item)
        find = true
      }
    }

    if (!find) {
      state.items.push(item)
    }
  },

  REMOVE_WHEEL_ITEM (state, { item }) {
    let index = state.items.findIndex(i => i.id === item.id)
    if (index !== -1) {
      state.items.splice(index, 1)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/wheel.js